import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from '@configs/axios';

const operations = {
    getTransactions: createApiService(
        (page = 1, type = '', query = '') => {
            // Only include request_type if type has a value
            const typeParam = type ? `&request_type=${type}` : '';
            const reqQuery = `?page=${page}${typeParam}${query}`;
            return axios.get(`/getTransactions${reqQuery}`);
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Transaction - Get Transactions' }
    ),

    getShetabTransactions: createApiService(
        (page = 1, transactionType = 1, query = '') => {
            // If transactionType is null, don't include transaction_type filter (for "all" option)
            const typeFilter = transactionType !== null ? `&transaction_type=${transactionType}` : '';
            const reqQuery = `?page=${page}&request_type=1${typeFilter}${query}`;
            return axios.get(`/getTransactions${reqQuery}`);
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Transaction - Get Shetab Transactions' }
    ),
    fetchCryptoTransactionHistory: createApiService(
        (page = 1, filter) => {
            return axios.post(`/user_wallets/wallet_transaction_history?page=${page}`, filter);
        },
        { ...API_CONFIGS.POST_ACTION, context: 'Transaction - Crypto History' }
    ),

    cancelTransactions: createApiService(
        (id, type) => {
            const url = type === 'deposit' ? `/user_wallets/deposit/${id}` : `/user_wallets/withdraw/${id}`;
            return axios.delete(url);
        },
        { ...API_CONFIGS.DELETE, context: 'Transaction - Cancel Transaction' }
    ),
    getDepositTransactionIdTips: createApiService(
        (id, type) => {
            return axios.get(`/user_wallets/deposit_id_tips`);
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Transaction - Deposit ID Tips' }
    ),

    getDepositShetabTips: createApiService(
        (id, type) => {
            return axios.get(`/user_wallets/deposit_id_tips`);
        },
        { ...API_CONFIGS.GET_WITH_DATA, context: 'Transaction - Deposit Shetab Tips' }
    )
}

export default operations
